// components/WhatsAppButton.js
"use client";
import React, { useState } from "react";

const Whatsappbutton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const contacts = [
    {
      name: "Visa World",
      image: "/fev.png",
      whatsappLink: "https://wa.me/971502870799?text=Hi+there!",
      imageStyles: "w-26 h-20", // Same here for Tushar
    },

    // {
    //   name: "Fardeen",
    //   image: "/fardeen.jpg",
    //   whatsappLink: "https://api.whatsapp.com/send/?phone=%2B918600027909&text=https%3A%2F%2Frbkpay.in%2F%0A%0A++++++++Hi+there%21++++++++%0A++++&type=phone_number&app_absent=0",
    //   imageStyles: "w-20 h-20", // Add height and width for Fardeen
    // },
  ];

  return (
    <div className="fixed bottom-14 right-4 z-50">
      {isOpen && (
        <div className="absolute bottom-16 right-0 mb-10 w-80 rounded-lg bg-white p-4 shadow-lg">
          <div className="mb-2 flex items-center justify-between border-b pb-2 ">
            <div className="flex items-center align-middle">
              <img
                src="/VISA WORLD NEW.jpg"
                alt="Visa World"
                className="w-22 align-center mb-2 mt-2 h-16  "
              />{" "}
              {/* Update with the actual path */}
            </div>
            <button onClick={() => setIsOpen(false)} className="text-gray-500">
              &times;
            </button>
          </div>
          {contacts.map((contact, index) => (
            <div
              key={index}
              className="flex cursor-pointer items-center p-2 hover:bg-gray-100"
              onClick={() => window.open(contact.whatsappLink, "_blank")}
            >
              <img
                src={contact.image}
                alt={contact.name}
                className="mr-3 h-10 w-10 rounded-full"
              />
              <div>
                <div className="font-bold text-black">{contact.name}</div>
                <div className="text-gray-700">Business Consultant</div>
                <div className="text-sm text-green">
                  online <span className="text-green">●</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 animate-pulsate rounded-full p-2 text-white shadow-lg focus:outline-none"
      >
        <img src="/logo.png" alt="WhatsApp" className="h-14 w-14" />{" "}
        {/* Update with the actual path */}
      </button>
    </div>
  );
};

export default Whatsappbutton;
